import { createAction, props } from '@ngrx/store';
import { PolicyHolder } from '../../interfaces/policyholder.model';

//    Register PolicyHolder
export const registerPolicyHolder = createAction(
  '[PolicyHolder] Register',
  props<{ formData: any }>()
);

export const registerPolicyHolderSuccess = createAction(
  '[PolicyHolder] Register Success',
  props<{ response: any }>()
);

export const registerPolicyHolderFailure = createAction(
  '[PolicyHolder] Register Failure',
  props<{ error: any }>()
);

//    Load By ID
export const loadPolicyHolderById = createAction(
  '[PolicyHolder] Load By Id',
  props<{ id: string }>()
);

export const loadPolicyHolderByIdSuccess = createAction(
  '[PolicyHolder] Load By Id Success',
  props<{ policyholder: PolicyHolder }>()
);

export const loadPolicyHolderByIdFailure = createAction(
  '[PolicyHolder] Load By Id Failure',
  props<{ error: any }>()
);

//    Update PolicyHolder
export const updatePolicyHolder = createAction(
  '[PolicyHolder] Update',
  props<{ id: string; changes: any }>()
);

export const updatePolicyHolderSuccess = createAction(
  '[PolicyHolder] Update Success',
  props<{ policyholder: PolicyHolder }>()
);

export const updatePolicyHolderFailure = createAction(
  '[PolicyHolder] Update Failure',
  props<{ error: any }>()
);

export const loadAllPolicyHolders = createAction(
  '[PolicyHolder] Load All',
  props<{ filters: any }>()
);

export const loadAllPolicyHoldersSuccess = createAction(
  '[PolicyHolder] Load All Success',
  props<{ policyholders: any[] }>()
);

export const loadAllPolicyHoldersFailure = createAction(
  '[PolicyHolder] Load All Failure',
  props<{ error: any }>()
);
